import { useCallback, useState } from 'react';

export function useModal(initialValue?: boolean) {
  const [showModal, setShowModal] = useState(initialValue || false);
  const closeModal = useCallback(() => setShowModal(false), []);
  const openModal = useCallback(() => setShowModal(true), []);
  return {
    closeModal,
    openModal,
    showModal,
  };
}
